export const DEFAULT_LANGUAGE = "en";
export const FALLBACK_LANGUAGE = "en";
export const SUPPORTED_LANGUAGES = [
  { code: "en", name: "English" },
  { code: "it", name: "Italiano" }
];
